"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceGroupsListResourceTypeEnum = exports.DirectoryV3Api = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var DirectoryV3Api = /** @class */ (function (_super) {
    __extends(DirectoryV3Api, _super);
    function DirectoryV3Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Updates or inserts charts unique to Medical Record Number(MRN) in a resource group.         Limited to 5000 records per request.
     */
    DirectoryV3Api.prototype.chartsUpsertBulkUpsertUpdateRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.chartV3Request === null || requestParameters.chartV3Request === undefined) {
                            throw new runtime.RequiredError('chartV3Request', 'Required parameter requestParameters.chartV3Request was null or undefined when calling chartsUpsertBulkUpsertUpdate.');
                        }
                        queryParameters = {};
                        if (requestParameters.cursor !== undefined) {
                            queryParameters['cursor'] = requestParameters.cursor;
                        }
                        if (requestParameters.pageSize !== undefined) {
                            queryParameters['page_size'] = requestParameters.pageSize;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/v3/charts/upsert/bulk-upsert",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: requestParameters.chartV3Request.map(models_1.ChartV3RequestToJSON),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PaginatedChartV3ListFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates or inserts charts unique to Medical Record Number(MRN) in a resource group.         Limited to 5000 records per request.
     */
    DirectoryV3Api.prototype.chartsUpsertBulkUpsertUpdate = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.chartsUpsertBulkUpsertUpdateRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     *
     */
    DirectoryV3Api.prototype.meOrgsMembershipsCreateRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.resourceGroupId === null || requestParameters.resourceGroupId === undefined) {
                            throw new runtime.RequiredError('resourceGroupId', 'Required parameter requestParameters.resourceGroupId was null or undefined when calling meOrgsMembershipsCreate.');
                        }
                        if (requestParameters.createResourceGroupMembershipRequest === null || requestParameters.createResourceGroupMembershipRequest === undefined) {
                            throw new runtime.RequiredError('createResourceGroupMembershipRequest', 'Required parameter requestParameters.createResourceGroupMembershipRequest was null or undefined when calling meOrgsMembershipsCreate.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/v3/me/orgs/{resourceGroupId}/memberships".replace("{".concat("resourceGroupId", "}"), encodeURIComponent(String(requestParameters.resourceGroupId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.CreateResourceGroupMembershipRequestToJSON)(requestParameters.createResourceGroupMembershipRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ResourceGroupMembershipFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     *
     */
    DirectoryV3Api.prototype.meOrgsMembershipsCreate = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.meOrgsMembershipsCreateRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     *
     */
    DirectoryV3Api.prototype.meOrgsRemoveDestroyRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.membershipId === null || requestParameters.membershipId === undefined) {
                            throw new runtime.RequiredError('membershipId', 'Required parameter requestParameters.membershipId was null or undefined when calling meOrgsRemoveDestroy.');
                        }
                        if (requestParameters.resourceGroupId === null || requestParameters.resourceGroupId === undefined) {
                            throw new runtime.RequiredError('resourceGroupId', 'Required parameter requestParameters.resourceGroupId was null or undefined when calling meOrgsRemoveDestroy.');
                        }
                        if (requestParameters.userId === null || requestParameters.userId === undefined) {
                            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling meOrgsRemoveDestroy.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/v3/me/orgs/{resourceGroupId}/{membershipId}/remove/{userId}".replace("{".concat("membershipId", "}"), encodeURIComponent(String(requestParameters.membershipId))).replace("{".concat("resourceGroupId", "}"), encodeURIComponent(String(requestParameters.resourceGroupId))).replace("{".concat("userId", "}"), encodeURIComponent(String(requestParameters.userId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     *
     */
    DirectoryV3Api.prototype.meOrgsRemoveDestroy = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.meOrgsRemoveDestroyRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates or inserts charts unique to Medical Record Number(MRN) in a resource group.         Limited to 5000 records per request.
     */
    DirectoryV3Api.prototype.meResourceGroupsChartsUpsertBulkUpsertUpdateRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.resourceGroupId === null || requestParameters.resourceGroupId === undefined) {
                            throw new runtime.RequiredError('resourceGroupId', 'Required parameter requestParameters.resourceGroupId was null or undefined when calling meResourceGroupsChartsUpsertBulkUpsertUpdate.');
                        }
                        if (requestParameters.chartV3Request === null || requestParameters.chartV3Request === undefined) {
                            throw new runtime.RequiredError('chartV3Request', 'Required parameter requestParameters.chartV3Request was null or undefined when calling meResourceGroupsChartsUpsertBulkUpsertUpdate.');
                        }
                        queryParameters = {};
                        if (requestParameters.cursor !== undefined) {
                            queryParameters['cursor'] = requestParameters.cursor;
                        }
                        if (requestParameters.pageSize !== undefined) {
                            queryParameters['page_size'] = requestParameters.pageSize;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/v3/me/resource-groups/{resourceGroupId}/charts/upsert/bulk-upsert".replace("{".concat("resourceGroupId", "}"), encodeURIComponent(String(requestParameters.resourceGroupId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: requestParameters.chartV3Request.map(models_1.ChartV3RequestToJSON),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PaginatedChartV3ListFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates or inserts charts unique to Medical Record Number(MRN) in a resource group.         Limited to 5000 records per request.
     */
    DirectoryV3Api.prototype.meResourceGroupsChartsUpsertBulkUpsertUpdate = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.meResourceGroupsChartsUpsertBulkUpsertUpdateRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List a queryset.
     */
    DirectoryV3Api.prototype.resourceGroupsCreateRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.resourceGroupRequest === null || requestParameters.resourceGroupRequest === undefined) {
                            throw new runtime.RequiredError('resourceGroupRequest', 'Required parameter requestParameters.resourceGroupRequest was null or undefined when calling resourceGroupsCreate.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/v3/resource-groups",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ResourceGroupRequestToJSON)(requestParameters.resourceGroupRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ResourceGroupFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * List a queryset.
     */
    DirectoryV3Api.prototype.resourceGroupsCreate = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resourceGroupsCreateRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List a queryset.
     */
    DirectoryV3Api.prototype.resourceGroupsDestroyRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling resourceGroupsDestroy.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/v3/resource-groups/{id}".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * List a queryset.
     */
    DirectoryV3Api.prototype.resourceGroupsDestroy = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resourceGroupsDestroyRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * List a queryset.
     */
    DirectoryV3Api.prototype.resourceGroupsListRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.count !== undefined) {
                            queryParameters['count'] = requestParameters.count;
                        }
                        if (requestParameters.idIn) {
                            queryParameters['id_in'] = requestParameters.idIn.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.name !== undefined) {
                            queryParameters['name'] = requestParameters.name;
                        }
                        if (requestParameters.ordering !== undefined) {
                            queryParameters['ordering'] = requestParameters.ordering;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.parentId !== undefined) {
                            queryParameters['parent_id'] = requestParameters.parentId;
                        }
                        if (requestParameters.practiceId !== undefined) {
                            queryParameters['practice_id'] = requestParameters.practiceId;
                        }
                        if (requestParameters.practiceIdIn) {
                            queryParameters['practice_id_in'] = requestParameters.practiceIdIn.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.resourceType !== undefined) {
                            queryParameters['resource_type'] = requestParameters.resourceType;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/v3/resource-groups",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PaginatedResourceGroupListFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * List a queryset.
     */
    DirectoryV3Api.prototype.resourceGroupsList = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resourceGroupsListRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List a queryset.
     */
    DirectoryV3Api.prototype.resourceGroupsMembershipsCreateRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.resourceGroupId === null || requestParameters.resourceGroupId === undefined) {
                            throw new runtime.RequiredError('resourceGroupId', 'Required parameter requestParameters.resourceGroupId was null or undefined when calling resourceGroupsMembershipsCreate.');
                        }
                        if (requestParameters.createResourceGroupMembershipRequest === null || requestParameters.createResourceGroupMembershipRequest === undefined) {
                            throw new runtime.RequiredError('createResourceGroupMembershipRequest', 'Required parameter requestParameters.createResourceGroupMembershipRequest was null or undefined when calling resourceGroupsMembershipsCreate.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/v3/resource-groups/{resourceGroupId}/memberships".replace("{".concat("resourceGroupId", "}"), encodeURIComponent(String(requestParameters.resourceGroupId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.CreateResourceGroupMembershipRequestToJSON)(requestParameters.createResourceGroupMembershipRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ResourceGroupMembershipFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * List a queryset.
     */
    DirectoryV3Api.prototype.resourceGroupsMembershipsCreate = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resourceGroupsMembershipsCreateRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List a queryset.
     */
    DirectoryV3Api.prototype.resourceGroupsMembershipsListRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.resourceGroupId === null || requestParameters.resourceGroupId === undefined) {
                            throw new runtime.RequiredError('resourceGroupId', 'Required parameter requestParameters.resourceGroupId was null or undefined when calling resourceGroupsMembershipsList.');
                        }
                        queryParameters = {};
                        if (requestParameters.count !== undefined) {
                            queryParameters['count'] = requestParameters.count;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/v3/resource-groups/{resourceGroupId}/memberships".replace("{".concat("resourceGroupId", "}"), encodeURIComponent(String(requestParameters.resourceGroupId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PaginatedResourceGroupMembershipListFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * List a queryset.
     */
    DirectoryV3Api.prototype.resourceGroupsMembershipsList = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resourceGroupsMembershipsListRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List a queryset.
     */
    DirectoryV3Api.prototype.resourceGroupsMembershipsRemoveDestroyRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.membershipId === null || requestParameters.membershipId === undefined) {
                            throw new runtime.RequiredError('membershipId', 'Required parameter requestParameters.membershipId was null or undefined when calling resourceGroupsMembershipsRemoveDestroy.');
                        }
                        if (requestParameters.resourceGroupId === null || requestParameters.resourceGroupId === undefined) {
                            throw new runtime.RequiredError('resourceGroupId', 'Required parameter requestParameters.resourceGroupId was null or undefined when calling resourceGroupsMembershipsRemoveDestroy.');
                        }
                        if (requestParameters.userId === null || requestParameters.userId === undefined) {
                            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling resourceGroupsMembershipsRemoveDestroy.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/v3/resource-groups/{resourceGroupId}/memberships/{membershipId}/remove/{userId}".replace("{".concat("membershipId", "}"), encodeURIComponent(String(requestParameters.membershipId))).replace("{".concat("resourceGroupId", "}"), encodeURIComponent(String(requestParameters.resourceGroupId))).replace("{".concat("userId", "}"), encodeURIComponent(String(requestParameters.userId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * List a queryset.
     */
    DirectoryV3Api.prototype.resourceGroupsMembershipsRemoveDestroy = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resourceGroupsMembershipsRemoveDestroyRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * List a queryset.
     */
    DirectoryV3Api.prototype.resourceGroupsPartialUpdateRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling resourceGroupsPartialUpdate.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/v3/resource-groups/{id}".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.PatchedResourceGroupUpdateRequestToJSON)(requestParameters.patchedResourceGroupUpdateRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PatientdataResourceGroupFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * List a queryset.
     */
    DirectoryV3Api.prototype.resourceGroupsPartialUpdate = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resourceGroupsPartialUpdateRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List a queryset.
     */
    DirectoryV3Api.prototype.resourceGroupsRetrieveRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling resourceGroupsRetrieve.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/v3/resource-groups/{id}".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PatientdataResourceGroupFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * List a queryset.
     */
    DirectoryV3Api.prototype.resourceGroupsRetrieve = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resourceGroupsRetrieveRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return DirectoryV3Api;
}(runtime.BaseAPI));
exports.DirectoryV3Api = DirectoryV3Api;
/**
 * @export
 */
exports.ResourceGroupsListResourceTypeEnum = {
    Org: 'Org',
    Worklist: 'Worklist'
};
